module.exports = __webpack_public_path__ + "static/media/tree_7.04d0974c.JPG";